/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SimpleNameV1Dto } from './SimpleNameV1Dto';
export type LocationToPartnerV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The type of the relation.
   */
  type?: LocationToPartnerV1Dto.type;
  /**
   * The beginning of the validity of the relation.
   */
  validFrom?: string | null;
  /**
   * The ending of the validity of the relation.
   */
  validTo?: string | null;
  /**
   * The uuid of the location linked to the partner. As 8-4-4-4-12 format.
   */
  readonly locationId: string;
  /**
   * The partner linked to location
   */
  partner: SimpleNameV1Dto;
};
export namespace LocationToPartnerV1Dto {
  /**
   * The type of the relation.
   */
  export enum type {
    LANDLORD = 'landlord',
    PROPERTY_MANAGER = 'property_manager',
    LANDLORD_MANAGER = 'landlord_manager',
  }
}
